// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1K7Ny","inputWrap":"CustomTip_inputWrap__Mmivm"};